import { pipe, Either, Runtime } from "fp";

import * as Data from "~/Data";
import * as Driver from "~/Driver";
import { Time } from "~/Time";
import { Route as GenericRoute } from "~/Route";

import * as MessageInteraction from "./MessageInteraction";
import * as Summary from "./Summary";
export * as Action from "./Action";
export * as MessageInteraction from "./MessageInteraction";
export * as MessengerList from "./MessengerList";
export * as Page from "./Page";
export * as Request from "./Request";
export * as Search from "./Search";
export * as Summary from "./Summary";

export type Sender = {
  readonly driver?: Driver.Driver;
  readonly alias: string;
  readonly selected: boolean;
};

export type Message = {
  readonly sender: string;
  readonly date: Time.DateTime;
  readonly text: string;
};

export const useStore = (): Data.Store.Store<readonly Message[]> =>
  Data.Store.useSelector(({ messages: { store } }) => store);

export const useDriverMessages = (driver: Driver.Driver): readonly Message[] =>
  pipe(
    useStore(),
    Data.Store.Get.fromReference({
      id: driver.id,
      missing: () => [],
      found: (messages) => messages,
    })
  );

export namespace Route {
  export const definition = () => "/messages" as const;
  export const href = () => definition();
  export const use = () => GenericRoute.use(href());
}

export namespace State {
  export type State = {
    readonly active: MessageInteraction.Active.State.State;
    readonly search: Driver.Search.Search;
    readonly sort: Driver.Sort.State.State;
    readonly store: Data.Store.Store<readonly Message[]>;
    readonly summary: Summary.State.State;
  };

  export const initial = (): State => ({
    active: MessageInteraction.Active.State.initial(),
    search: Driver.Search.State.initial(),
    sort: Driver.Sort.State.initial(),
    store: Data.Store.initial(),
    summary: Summary.State.initial(),
  });
}

export namespace Response {
  export const runtime = () =>
    Runtime.strict({
      sender: Runtime.string(),
      date: Runtime.string(),
      text: Runtime.string(),
    });

  export const decode = (
    response: Runtime.ToType<typeof runtime>
  ): Message => ({
    sender: `${response.sender}`,
    date: pipe(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      Time.DateTime.fromString(response.date),
      Either.getOrElse(() => Time.DateTime.now())
    ),
    text: response.text,
  });
}
